import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'lib-ph-bhp-sop-statical-evaluation',
  templateUrl: './ph-bhp-sop-statical-evaluation.component.html',
  styleUrls: ['./ph-bhp-sop-statical-evaluation.component.css']
})
export class PhBhpSopStaticalEvaluationComponent implements OnInit {

  @Output() childData = new EventEmitter();
  @Input() filterDetails
  constructor() { }

  ngOnInit() {
  }  
  emitData(valve){
    this.childData.emit(valve)
  }
}